import FacebookIcon from 'assets/icons/landing/facebook'
import InstaIcon from 'assets/icons/landing/insta'
import TiktokIcon from 'assets/icons/landing/tiktok'
import logoDark from 'assets/images/landing/logo-dark.png'
import logoLight from 'assets/images/landing/logo-light.png'
import BodyText from 'components/UI/Landing/body-text'
import Container from 'components/UI/Landing/container'
import { ThemeContext, ThemeProviderContext } from 'contexts/theme-context'
import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import SuperappBanner from './superapp-banner'

export default function FooterBottom(): JSX.Element {
  const { t } = useTranslation('footer')
  const themeContext = useContext(ThemeContext)
  const { theme } = themeContext as ThemeProviderContext
  const isDark = theme === 'dark'

  return (
    <footer className='py-5 border-t border-grey-middle'>
      <Container>
        <div className='flex flex-wrap justify-between mb-10 sm:hidden'>
          <img src={isDark ? logoLight : logoDark} alt='LOGO' className='w-[150px]' />
          <div className='flex  gap-2 text-muted'>
            <a
              href='https://instagram.com/'
              target='_blank'
              className='p-3 bg-secondary rounded-full text-[#5C5C5C]'
              rel='noreferrer'
            >
              <InstaIcon />
            </a>
            <a
              href='https://facebook.com/'
              target='_blank'
              className='p-3 bg-secondary rounded-full text-[#5C5C5C]'
              rel='noreferrer'
            >
              <FacebookIcon />
            </a>
            <a
              href='https://tiktok.com/'
              target='_blank'
              className='p-3 bg-secondary rounded-full text-[#5C5C5C]'
              rel='noreferrer'
            >
              <TiktokIcon />
            </a>
          </div>
        </div>
        <SuperappBanner className='sm:hidden' />
        <BodyText
          className='mt-6 sm:mt-0'
          text={
            <Trans
              ns='footer'
              values={{
                year: new Date().getFullYear()
              }}
            >
              {t('footer.license')}
            </Trans>
          }
        />
      </Container>
    </footer>
  )
}